import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'sucessoFalhaPipe',
    pure: true
})

export class SucessoFalhaPipe implements PipeTransform {

    transform(value: boolean, args?: any): any {

        return (value == true ? 'SUCESSO' : 'FALHA');
    }

}
